import {
    GETOPTICSHOPOPDBILL,
    CREATEOPTICSHOPOPDBILL,
    UPDATEOPTICSHOPOPDBILL,
    DELETEOPTICSHOPOPDBILL,
    GETOPTICSHOPOPDPAYMENTRECEIPT,
    CREATEOPTICSHOPOPDPAYMENTRECEIPT,
    UPDATEOPTICSHOPOPDPAYMENTRECEIPT,
    DELETEOPTICSHOPOPDPAYMENTRECEIPT,
} from "../actions/types"

const initialState = {}

export default function (state = initialState, action) {
    switch (action.type) {

        case GETOPTICSHOPOPDBILL:
            return {
                ...state,
                OpticShopBillPrintList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDBILL:
            return {
                ...state,
                OpticShopBillPrintSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDBILL:
            return {
                ...state,
                OpticShopBillPrintUpdateStatus: action.payload.success,
            };

        case DELETEOPTICSHOPOPDBILL:
            return {
                ...state,
                OpticShopBillPrintDeleteStatus: action.payload.success,
            };
        case GETOPTICSHOPOPDPAYMENTRECEIPT:
            return {
                ...state,
                OpticShopPaymentReceiptList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDPAYMENTRECEIPT:
            return {
                ...state,
                OpticShopPaymentReceiptSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDPAYMENTRECEIPT:
            return {
                ...state,
                OpticShopPaymentReceiptUpdateStatus: action.payload.success,
            };

        case DELETEOPTICSHOPOPDPAYMENTRECEIPT:
            return {
                ...state,
                OpticShopPaymentReceiptDeleteStatus: action.payload.success,
            };

        default:
            return state;
    }
}